<template>
  <div>
    <div class="topBox">
      <div class="banner">
        <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item>
            <van-image
              fit="fill"
              :src="require('@/../static/banner.jpg')"
            ></van-image>
          </van-swipe-item>
        </van-swipe> -->
        <van-image
          class="bannerImg"
          fit="fill"
          :src="require('@/../static/banner.jpg')"
        ></van-image>
      </div>
      <search-input ref="search" @search="handleSearch"></search-input>
    </div>
    <van-tabs v-model="active" sticky @click="backTop()">
      <van-tab title="进行中">
        <detail-info
          :status="100"
          :cilentHeight="cilentHeight"
          ref="detailInfo"
          @getKey="getKey"
          v-if="active === 0"
        ></detail-info>
      </van-tab>
      <van-tab title="已完成">
        <detail-info
          :status="2"
          :cilentHeight="cilentHeight"
          ref="detailInfo"
          @getKey="getKey"
          v-if="active === 1"
        ></detail-info>
      </van-tab>
      <van-tab title="已取消">
        <detail-info
          :status="-1"
          :cilentHeight="cilentHeight"
          ref="detailInfo"
          @getKey="getKey"
          v-if="active === 2"
        ></detail-info>
      </van-tab>
    </van-tabs>
    <div class="goFooter flex whiteBg">
      <div class="goFastMail" @click="goFastMail">
        <img src="@/../static/icon-go.svg" alt="" />
        <span style="margin-left:10px">寄快递</span>
      </div>
    </div>
  </div>
</template>
<script>
import detailInfo from './components/detailInfo'
import searchInput from '@/components/search'
export default {
  data() {
    return {
      value: '',
      active: 0,
      cilentHeight: 0,
      status: 100,
      userInfo: null,
      images: ['../../../../static/banner.jpg']
    }
  },
  components: {
    detailInfo,
    searchInput
  },
  // beforeRouteLeave(to, from, next) {
  //   from.meta.keepAlive = true // 让该页面缓存
  //   next()
  // },
  mounted() {
    this.cilentHeight = document.documentElement.clientHeight
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  methods: {
    handleSearch(key) {
      this.$refs.detailInfo.handleSearch(key)
      // console.log(this.$refs)
    },
    goFastMail() {
      this.$store.commit('clearInfo')
      this.$router.push({ name: 'goFastMail' })
    },
    getKey() {
      this.$refs.detailInfo.searchKey = this.$refs.search.value
    },
    backTop() {
      // const that = this
      let timer = setInterval(() => {
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-scrollTop / 6)
        if (scrollTop === 0) {
          clearInterval(timer)
        }
        if (document.documentElement.scrollTop) {
          document.documentElement.scrollTop += ispeed
        }
        if (document.body.scrollTop) {
          document.body.scrollTop += ispeed
        }
      }, 16)
    }
  }
}
</script>
<style lang="scss">
.topBox {
  padding: 10px;
  background-color: #fff;
}
.banner {
  border-radius: 10px;
  overflow: hidden;
  height: 150px;
  @media screen and (min-width: 768px) {
    height: 200px;
  }
  @media screen and (min-width: 1024px) {
    height: 240px;
  }
  .bannerImg {
    height: 100%;
  }
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    background-color: #ccc;
  }
}

.goFooter {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  left: 50%;
  width: 100vw;
  height: 54px;
  transform: translateX(-50%);
}
.goFastMail {
  width: calc(100% - 20px);
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: #a30014;
  border-radius: 22px;
}
</style>
